{
  "section_table": {
    "caption": "Company sections",
    "search": "Search sections",
    "inherited": "Inherited",
    "headings": {
      "name": "Section",
      "customer_group": "Customer group",
      "price_lists": "Price lists",
      "company_users": "Customers",
      "current_balance": "Balance",
      "admins": "Section admins"
    },
    "actions": {
      "add_child": "Add sub-section"
    }
  },
  "section_form": {
    "move_node": "Change current position",
    "parent": {
      "title": "Placement",
      "description": "Where this section sits in the company hierarchy. It inherits the settings of everything above it.",
      "label": "Parent section",
      "top_level": "Top level (directly under the company)",
      "top_level_named": "Top level (directly under {company})"
    },
    "sibling": {
      "label": "Positon under parent",
      "description": "Will place this section before the chosen option",
      "last_label": "Bottom of list"
    }
  },
  "section_customers": {
    "title": "Customers",
    "description": "The company's customers who belong to this section, and what each one can do.",
    "select_label": "Assigned customers",
    "role_list_error": "We couldn't load the list of roles. Roles can't be changed until it loads.",
    "non_leaf": {
      "title": "This section has sub-sections",
      "description": "Customers can only belong to a section at the bottom of the hierarchy. Assign them to one of this section's sub-sections instead."
    },
    "table": {
      "caption": "Customers assigned to this section",
      "headings": {
        "customer": "Customer",
        "role": "Role"
      }
    }
  },
  "section_admins": {
    "title": "Admins",
    "description": "Customers who look after this section and every section below it. They can see and approve every order placed there.",
    "select_label": "Section admins"
  }
}
